import { MB } from '@app/constant/sizes';

export const FREE_EXPIRY = '1w';
export const FREE_EXPIRY_ON_CHANNEL = '1m';
export const MAX_MESSAGE_SIZE_IN_BYTES = 65535;

// From Devise: /\A[^@\s]+@([^@\s]+\.)+[^@\s]+\z/
export const REGEXP_EMAIL_LABEL = /^((.+\s)<([^@\s]+@([^@\s]+\.)+[^@\s]+)>|(<|\(|')?([^@\s]+@([^@\s]+\.)+[^@\s>)']+)('|\)|>)?)$/im;
export const REGEXP_EMAIL = /^([^@\s]+@([^@\s]+\.)+[^@\s]+)$/im;
export const REGEXP_BLANK = /\s*/g;

export const TransferConfig = Object.freeze({
  // Settings for chunk uploads
  upload: {
    chunk: {
      minSize: 15 * MB, // Same as the value in file_object.rb
      maxCount: 999,
    },

    retry: {
      limit: 100,
      interval: 2000,
    },

    remainingTimeInterval: 10000,

    progressInterval: 500,
  },

  // Settings for the queue
  queue: {
    concurrency: 3,
    retryLimit: 10,
  },

  // Settings for API requests
  api: {
    endpoint: '/api/v4',
    // Timeout regular requests in 30s
    timeout: 30 * 1000,
    retry: {
      limit: 100,
    },
  },
});
